var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b2b-input-layout",class:{
    'b2b-input-layout--hidden': _vm.hidden,
    'b2b-input-layout--has-value': !!_vm.value,
    'b2b-input-layout--focused': !!_vm.focused,
    'b2b-input-layout--disabled': _vm.disabled,
  }},[_vm._t("prepend"),_vm._t("default"),_c('div',{staticClass:"b2b-input-layout__border"},[_c('div',{staticClass:"b2b-input-layout__border-left"}),_c('div',{staticClass:"b2b-input-layout__border-label"},[_c('label',{staticClass:"input__label",attrs:{"for":_vm.id},domProps:{"textContent":_vm._s(_vm.label)}})]),_c('div',{staticClass:"b2b-input-layout__border-right"})]),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }